<template>
  <div>
    <div v-if="debug_show_page_name==true" style="color:green;">certificate-list-modal</div>
    <modal class="yobiki_select-modal" width="460px"   :value="showModal" effect="fade" @closed="closed"  large>
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <center><strong>証書管理番号</strong></center>
        </h4>
      </div>
      <div  class="modal-body yobiki_select-modal-body " style="height: 500px;padding: 0px 15px; overflow-x: auto;" >
        <ag-grid-vue style="min-width:100px;width: 100%; height: 475px" class="ag-blue" :gridOptions="gridOptions" :rowData="rowData"></ag-grid-vue>
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <div style="float:left">
          <input class="form-control"  type="text" placeholder="検索"
          id="yobiki-search" name="yobiki-search"
          :value="searchModel"
          @input="onSearch($event.target.value)"
          >
        </div>
        <button type="button" class="btn btn-default " @click="closed('no')">キャンセル</button>
        <button type="button" class="btn btn-primary " @click="closed('yes')" >OK</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { bus } from '@/libs/bus';
import { utils } from '@/libs/utils';
var vm = this;

import modal from './local-modal';
import output_config from '../../rules/output_config.js';
import { AgGridVue } from 'ag-grid-vue';
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";

Vue.component('modal', modal);
import _ from 'lodash';
import debug from 'debug';
var debug_yobiki = debug('esma:certificate-list-modal');
export default {
   mixins:[
        mixinPageCommon,mixinDatasource
  ],
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      show_modal: false,
      selected_data :false,
      row_data:[],
      api_name:"certificate",
      search_timeout : false,
      search_model:"",
      device_control_number:false,
      state_last_filter_options:"last_filter_options3",
      selected_row :false
    };
  },
  computed: {
    selectedRow:{
      get(){
        return this.selected_row;
      },
      set(v){
        this.selected_row = v;
      }
    },
    searchModel:{
      get(){
        return this.search_model;
      },
      set(v){
        this.search_model = v;
      }
    },
    rowData:{
      get(){
        return this.row_data;
      },
      set(v){
        this.row_data = v;
      }
    },
    selectedData:{
      get(){
        return this.selected_data;
      },
      set(v){
        this.selected_data = v;
      }
    },

    pageID() {
      return this.$props.pageid;
    },
    showModal() {
      return this.show_modal;
    }
  },
  methods: {
    onSearch(txt){
      clearTimeout(this.search_timeout);
      this.search_timeout = setTimeout(()=>{
        var b2 = (txt == "")?false:{block: "2", field: "certificate_management_number", value: txt, ct: "v", ca: false, t: "input"};
        var b3 = false//(typeof this.company == "undefined" || this.company == false || this.company.length == 0)?false:{block: "3", field: "company", value: this.company, ct: "v", ca: false, t: "select"};
        if(b2 == false){
          b2 = _.clone(b3);
          b3 = false;
        }
        this.searchControlChangedDatasource(
          {
            "1":{block: "1", field: "certificate_management_number", value: "NOT_EMPTY_VALUE", ct: "v", ca: false, t: "input"},
            "2":b2,
            "3": b3,
            "j1": "AND",
            "j2": "AND",
            "b2_disabled": false,
            "b3_disabled": true
          }
        )
      },(txt == "")?0:300)
    },
    cancelCurrentSelection() {
      //Dummy, needed due mixinDataSource
    },
    updateValue(vm, ev, mode, cb=()=>{}){
      if (ev.node.isSelected()) {
        this.selectedData = ev.node.data.certificate_management_number;
        this.selectedRow = ev.node.data;
      }
    },
    onShow() {
        this.company = this.$store.state[this.stateCurrentEditing].company || this.$store.state[this.stateCurrentRow].company || false;
        this.onSearch("");
      this.searchModel = "";
      this.selectedData = false;
      this.selectedRow = false
      this.$notify({clean: true});
      this.$notify({
        title: "Loadding....",
        type: "success",
        duration: 1000
      });
    },
    showModalWindow(data) {
      debug_yobiki("showModalWindow");
      this.show_modal = true;
      this.device_control_number = (data && data.device_control_number && data.device_control_number.length > 0 )?data.device_control_number : false;
      this.onShow();
    },
    closed(mode) {
      debug_yobiki('mode', mode);
      if(mode == "yes" && this.selectedData){
        this.$emit("selected",this.selectedData,this.selectedRow)
        setTimeout(()=>{
          this.selectedData = "";
          this.selectedData = false;
          this.selectedRow = false;
        },100)
      }else if(mode == "yes"){
        var last_terminal = false;
        var last_data = false;
        var count_rows = 0;
        this.gridOptions.api.forEachNode((node) => {
          if(typeof node != "undefined" && typeof node.data != "undefined"  ){
            if(typeof node.data.seq_id != "undefined"){
              if(count_rows == 0){
                last_terminal = node.data.number_cert;
                last_data = node.data;
              }
              count_rows++;
            }
          }
        })
        if(count_rows == 1 && last_terminal != false){
          this.$emit("selected",last_terminal,last_data)
        }
      }
      this.show_modal = false;
      this.$emit('done', mode);
    },
    createColumnDefs(){
      return [
        {
          headerName: '証書管理番号',
          field: 'certificate_management_number',
          hide: false,
          sort: 'desc',
          width:392
        },
        {
          headerName: 'Seq', 
          field: 'seq_id',
          hide: false,
          sort: 'desc',
          width:392
        },
        {
            headerName: "SearchFlowControl",// Used to filter manually
            field: "search_flow_control",
            hide: false
        },
    ];
    }
  },
  props: {
    tag: { type: String, default: 'showCertificateListModal' },
    pageid: { type: String }
  },
   beforeMount() {
    // this.$store.state.current_row = {};

    //AG Grid options
    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function(data) {
        return data.seq_id;
      },
      enableSorting: true,
      enableColResize: false,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate :"<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onRowSelected: ev => {
        this.updateValue(this, ev, 'load_yobiki');
      },
    };
    // this.api_request_options = {sub_search:"device_control_number"};
    this.initDatasource({load_only_with_filter:true});
  },
  mounted() {
    debug_yobiki('On mounted');
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  }
};

</script>
<style scoped>

.info_div {
  width: 32%;
  float: left;
}
.mh_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.mh_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
.fa-spin-custom, .glyphicon-spin {
    -webkit-animation: spin 1500ms infinite linear;
    animation: spin 1500ms infinite linear;
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
</style>



// WEBPACK FOOTER //
// certificate-list-modal.vue?0ec8a211